import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import BindingItemSortable from "./BindingItemSortable";

const BindingItems = ({
  bindings,
  bindingsList = [],
  onAddGroup,
  onAddBinding,
  defaultLanguage,
  onDelete,
  allProducts,
  currencyCode,
  onSortEnd,
  onChipSortEnd,
}) => {
  const [bindingList, setBindingList] = useState([]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  useEffect(() => {
    const excludedKeys = ["name", "min", "max", "bindingId", "required"];
    const bindingList = Object.keys(bindings || {})
      .map((key, i) => {
        if (excludedKeys.includes(key)) {
          return null;
        }
        const binding = bindings[key];
        const index = binding.index === undefined ? i : binding.index;

        return { ...binding, code: key, index };
      })
      .filter((binding) => binding)
      .sort((b1, b2) => b1.index - b2.index);
    setBindingList(bindingList);
  }, [bindings]);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = bindingList.findIndex((item) => item.code === active.id);
      const newIndex = bindingList.findIndex((item) => item.code === over.id);

      const newBindingList = arrayMove(bindingList, oldIndex, newIndex);
      setBindingList(newBindingList);

      if (onSortEnd) {
        onSortEnd({ oldIndex, newIndex });
      }
    }
  };

  const handleChipSortEnd = (bindingCode, oldIndex, newIndex) => {
    if (onChipSortEnd) {
      onChipSortEnd(bindingCode, oldIndex, newIndex);
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={bindingList.map((item) => item.code)}
        strategy={verticalListSortingStrategy}
      >
        <Grid container columnSpacing={2} rowSpacing={2}>
          {bindingList.map((binding) => {
            return (
              <Grid
                item
                xs={12}
                key={`${new Date().getTime()}_${binding.index}`}
              >
                <BindingItemSortable
                  id={binding.code}
                  index={binding.index}
                  code={binding.code}
                  binding={binding}
                  bindingsList={bindingsList}
                  defaultLanguage={defaultLanguage}
                  allProducts={allProducts}
                  currencyCode={currencyCode}
                  onAddGroup={onAddGroup}
                  onAddBinding={onAddBinding}
                  onDelete={onDelete}
                  onChipSortEnd={handleChipSortEnd}
                />
              </Grid>
            );
          })}
        </Grid>
      </SortableContext>
    </DndContext>
  );
};

export default BindingItems;
